import Vue from 'vue';
import {
  init,
  rewriteFramesIntegration,
  browserTracingIntegration,
  setTags,
  setUser,
  addIntegration,
} from '@sentry/vue';

import { getCorrelationId } from '@paybis/frontend-common-lib/src/services/correlation';
import TokenService from '@paybis/frontend-common-lib/src/services/token';
import { isUserCountryUK } from '@/helpers/userCountry';

import { baseConfig } from './sentry-config';

function initSentry() {
  if (!baseConfig.dsn) {
    return;
  }

  try {
    init({
      Vue,
      ...baseConfig,
      integrations: [
        rewriteFramesIntegration(),
        browserTracingIntegration(),
      ],
      replaysSessionSampleRate: 0.01,
      replaysOnErrorSampleRate: 0.3,
    });

    setTags({
      correlation_id: getCorrelationId(),
    });

    const user = TokenService.getUser();
    if (user) {
      setUser(user);
    }

    loadReplayIntegration();
  } catch (e) {
    console.warn('Sentry init failed', e);
  }
}

async function loadReplayIntegration() {
  try {
    const [{ replayIntegration }, { getReplayIntegrationOptions }] = await Promise.all([
      import('@sentry/replay'),
      import('./sentry-integrations'),
    ]);

    const replay = replayIntegration(getReplayIntegrationOptions());
    addIntegration(replay);

    if (isUserCountryUK()) {
      replay.start();
    }
  } catch {
    // Dynamic import can fail during deployments (stale chunk URLs become 404)
    // or due to network issues. Replay is non-critical, so silently degrade.
  }
}

if (process.env.NODE_ENV === 'production') {
  initSentry();
}
